<template>
  <div class="text-center">
    <!--    <page-header></page-header>-->
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col
        cols="12"
        class="icon-title word-type-txt pb-4 d-flex justify-space-between"
      >
        <div><icon-application :width="24" :height="24" />학자금</div>
      </v-col>
    </v-row>
    <v-card class="card-group">
      <div class="card-title">
        <v-card-title> 결재자 </v-card-title>
        <v-icon>mdi-chevron-down</v-icon>
      </div>

      <!--list-->
      <v-list lines="three" class="card-cont-group">
        <v-list
          class="d-flex bg-surface-variant flex-row justify-space-between"
        >
          <v-chip class="mb-3 lightgreen" density="compact" size="x-small"
            >기안</v-chip
          >
          <div class="list-status point-blue">
            결재완료<v-icon class="point-blue s16">mdi-check</v-icon>
          </div>
        </v-list>
        <v-list class="d-flex align-start flex-column bg-surface-variant">
          <v-list-item-title class="align-self-start list-name"
            >홍길동</v-list-item-title
          >
          <v-list-item-subtitle class="list-level">
            대리 <span class="mx-1"> | </span>총무팀
          </v-list-item-subtitle>
        </v-list>
        <v-divider></v-divider>
      </v-list>
      <!--//list-->

      <!--list-->
      <v-list lines="three" class="card-cont-group">
        <v-list
          class="d-flex bg-surface-variant flex-row justify-space-between"
        >
          <v-chip class="mb-3 lightblue" density="compact" size="x-small"
            >결재</v-chip
          >
          <div class="list-status point-green">
            결재요청<v-icon class="point-green s16">mdi-help</v-icon>
            <!--반려시 적용<v-icon class="point-red s16">mdi-close</v-icon>결재요청-->
          </div>
        </v-list>
        <v-list class="d-flex align-start flex-column bg-surface-variant">
          <v-list-item-title class="align-self-start list-name"
            >홍길동</v-list-item-title
          >
          <v-list-item-subtitle class="list-level">
            대리 <span class="mx-1"> | </span>총무팀
          </v-list-item-subtitle>
        </v-list>
        <v-list>
          <v-list
            class="flex-1-0 d-flex flex-column align-start bg-surface-variant list-reply"
          >
            <v-list-item class="mb-1 list-reply-title">의견</v-list-item>
            <v-list-item class="list-reply-text">반려합니다.</v-list-item>
          </v-list>
        </v-list>
      </v-list>
      <!--//list-->
    </v-card>

    <v-card class="card-group">
      <div class="card-title">
        <v-card-title> 첨부파일 </v-card-title>
        <v-icon>mdi-chevron-down</v-icon>
      </div>
    </v-card>
    <v-card class="card-group">
      <div class="card-title">
        <v-card-title> 담당자 </v-card-title>
        <v-icon>mdi-chevron-down</v-icon>
      </div>
    </v-card>

    <!--btn one 적용-->
    <v-bottom-navigation
      v-model="value"
      :input-value="active"
      fixed
      scroll-threshold="500"
      height="96"
    >
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="12">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-blue"
            @click="$emit('goApplMenuList')"
          >
            <span class="white--text">회수하기</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>
    <!--btn double 적용
        <v-bottom-navigation
          v-model="value"
          :input-value="active"
          fixed
          scroll-threshold="300"
          height="96"
        >
          <v-row
            class="d-flex flex-row justify-space-between py-5 px-8 btn-fixed-wrapper"
          >
            <v-col cols="6" class="pr-1">
              <v-btn
                block
                elevation="0"
                class="btn-fixed btn-red"
                @click="$emit('goApplMenuList')"
              >
                <span class="white--text">반려</span>
              </v-btn>
            </v-col>
            <v-col cols="6" class="pl-1">
              <v-btn
                block
                elevation="0"
                class="btn-fixed btn-blue"
                @click="$emit('goApplMenuList')"
              >
                <span class="white--text">결재</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-bottom-navigation>-->
  </div>
</template>
<script>
//import PageHeader from '@/components/common/PageHeader.vue';
import IconApplication from '@/assets/customIcon/IconApplication.vue';

export default {
  computed: {},
  components: {
    // PageHeader,
    IconApplication,
  },
};
</script>
